import {Constants} from "@/constant/Constants";
import {SelectData} from "@/data/SelectData";
import { OutcomeType } from '@/types';

export class Outcome extends SelectData{
    private _sequence: string;

    constructor(data: OutcomeType) {
        super();
        this._name = data[Constants.NAME];
        this._id = data[Constants.NAME];
        this._sequence = data[Constants.SEQUENCE];
    }
    get sequence(): string {
        return this._sequence;
    }

    set sequence(value: string) {
        this._sequence = value;
    }

}